export const TOPICS = {
    MY_STORE_MODULE_UPDATES: 'myStoreModuleUpdates',
};

export const CUSTOM_EVENTS = {
    MY_STORE_MODULE_UPDATES: 'kmxSubscribeToMyStoreModuleUpdates',
};
